// global
import { LOCATION_CHANGE } from 'react-router-redux';
// import * as types from '../actions/padInitialization.types';
import * as types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../constants/status.constant';

const initialState = {
  show: false,
  title: '',
  success: true,
  status: STATUS.IDLE,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return { ...initialState };
    }
    case types.ACTION_TYPES.FEEDBACK_PENDING: {
      return { ...state, status: STATUS.LOADING, error: null };
    }
    case types.ACTION_TYPES.FEEDBACK_FAILURE: {
      return {
        ...state,
        status: STATUS.FAILED,
        error: action.payload || new Error('Feedback failed'),
        show: true,
        title: state.title,
        success: false
      };
    }
    case types.ACTION_TYPES.FEEDBACK_SUCCESS: {
      const payload = action.payload || {};
      return {
        show: payload.show !== undefined ? payload.show : true,
        title: payload.title || '',
        success: payload.success !== undefined ? payload.success : true,
        status: STATUS.SUCCEEDED,
        error: null
      };
    }
    case types.ACTION_TYPES.FEEDBACK_CLEAR: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default reducer;
